var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-flex flex-column h-full"},[_c('div',{staticClass:"flex-grow-1 scroll-y"},[_c('List'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }